module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0034.jpg?v=c4195191";